"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconWithHoverText = void 0;
const classnames_1 = __importDefault(require("classnames"));
const React = __importStar(require("react"));
const react_1 = require("react");
const Icon_1 = __importDefault(require("../Icon"));
const HoverBox_1 = require("./HoverBox");
const IconWithHoverText = (props) => {
    const [hoverBoxVisible, setHoverBoxVisible] = react_1.useState(false);
    const iconWithHoverTextInner = classnames_1.default({
        'icon-with-hover-text': true,
        'icon-with-hover-text-xs': props.size === 'xs',
        [props.className]: !!props.className,
    });
    const iconWithHoverTextInnerIcon = classnames_1.default({
        'inner-icon': true,
        'inner-icon-on-hover': hoverBoxVisible,
    });
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: iconWithHoverTextInner },
            React.createElement("div", { className: iconWithHoverTextInnerIcon, onMouseOver: () => setHoverBoxVisible(true), onMouseLeave: () => !props.includeSidebar ? setHoverBoxVisible(false) : null },
                React.createElement(Icon_1.default, { icon: props.icon })),
            hoverBoxVisible && (React.createElement(HoverBox_1.HoverBox, { text: props.text, includeSidebar: props.includeSidebar, closeIcon: () => setHoverBoxVisible(false), hoverBoxAlign: props.hoverBoxAlign })))));
};
exports.IconWithHoverText = IconWithHoverText;
//# sourceMappingURL=IconWithHoverText.js.map